import {RootState} from 'store/store';

export const selectorGetVerifyEmail = (store: RootState): string => store.avaRedux.email;

export const selectorGetProfile = (store: RootState): any => store.avaRedux.profile;

export const selectorGetProfileUpdate = (store: RootState): any => store.avaRedux.profileUpdate;

export const selectorGetOrgDetails = (store: RootState): any => store.avaRedux.org;
